import {useEffect } from '../../InBuildImports';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {systemConfiguration,Properties,includeScripts,includeBootstrapCss ,includeBundleBootstrapCss} from '../../CommonImports';
import  './../css/GRecentJobs.css';
import  './../css/GBrowsebycategory.css';
import  './../css/GSideBar.css';
import  './../css/GPostJob.css';
import  './../css/GMediaQuery.css';
import  './../css/Gtop.css';
import  './../css/GAnimetion.css';
import  './../css/GGraphicJob.css';
import  './../css/GFooter.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import GHeader from "./GHeader";
import GBrowseByCategory from "./GBrowseByCategory";
import GFooter from "./GFooter";
import GPostJob from './GPostJob';
import GRecentJobs from './GRecentJobs';
import GJobsHubMenu from "./GJobsHubMenu";


function GJobsIndex() {
     const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
     const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

     useEffect(() => {
                includeBootstrapCss();
                includeBundleBootstrapCss();
                includeScripts();
                document.addEventListener("DOMContentLoaded", function () {
                  if (window.innerWidth >= 992) {
                    const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                    sidebar.show();
                  }
              });
         }, []);
     
         
return (
    <div>
       <GHeader/>

  <GJobsHubMenu/>


<div  data-select2-id="13">
      <section className="section-box" data-select2-id="12">
        <div className="banner-hero hero-1" data-select2-id="11">
          <div className="banner-inner" data-select2-id="10">
            <div className="row" data-select2-id="9">
              <div className="col-lg-8" data-select2-id="8"> 
                <div className="block-banner" data-select2-id="7">
                  <span className="text-small-primary text-small-primary--disk text-uppercase wow animate__ animate__fadeInUp animated" style={{visibility:"visible",animationName:"fadeInUp"}}>Best jobs place</span>
                  <h1 className="heading-banner wow animate__ animate__fadeInUp animated" style={{visibility:"visible",animationName:"fadeInUp"}}>The Easiest Way to Get Your New Job</h1>
                  <div className="banner-description mt-30 wow animate__ animate__fadeInUp animated" data-wow-delay=".1s" style={{visibility:"visible",animationDelay:"0.1s",animationName:"fadeInUp"}}>
                    Each month, more than 3 million job seekers turn to website in their search for work, making over 140,000 applications every single day
                  </div>

           
        
        <GPostJob/>


       

            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="banner-imgs">
              <img alt="jobhub" src={mediaUrl+"banner.png?"+sasToken} className="img-responsive shape-1"/>
              <span className="union-icon"><img alt="jobhub" src={mediaUrl+"union.svg?"+sasToken} className="img-responsive shape-3"/></span>
              <span className="congratulation-icon"><img alt="jobhub" src={mediaUrl+"congratulation.svg?"+sasToken} className="img-responsive shape-2"/></span>
              <span className="docs-icon"><img alt="jobhub" src={mediaUrl+"docs.svg?"+sasToken} className="img-responsive shape-2"/></span>
              <span className="course-icon"><img alt="jobhub" src={mediaUrl+"course.svg?"+sasToken} className="img-responsive shape-3"/></span>
              <span className="web-dev-icon"><img alt="jobhub" src={mediaUrl+"web-dev.svg?"+sasToken} className="img-responsive shape-3"/></span>
              <span className="tick-icon"><img alt="jobhub" src={mediaUrl+"tick.svg?"+sasToken} className="img-responsive shape-3"/></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <GBrowseByCategory/>



<GRecentJobs/>




        <section className="section-box mt-50 mb-0 bg-patern">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <div className="content-job-inner">
                           <h2 className="section-title heading-lg animate__animated animate__fadeInUp">The #1 Job Board for Graphic Design Jobs</h2>
                            <div className="mt-40 pr-50 text-md-lh28 animate__animated animate__fadeInUp">Search
							 and connect with the right candidates faster. This talent seach gives 
							you the opportunity to find candidates who may be a perfect fit for your
							 role</div>
                            <div className="mt-40">
                                <div className="box-button-shadow animate__animated animate__fadeInUp"><a href="#" className="btn btn-primary btn-sm">Post a job now</a></div>
                               <a href="#" className="btn btn-link animate__animated animate__fadeInUp">Learn more</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="box-image-job">
                           <figure className="animate__animated animate__fadeIn">
							  <img alt="jobhub" src={mediaUrl+"img-job.png?"+sasToken}/>
							</figure>
                            <div className="job-top-creator">
                                <div className="job-top-creator-head">
                                    <h5>Top Freelancers</h5>
                                </div>
                                <ul>
                                    <li>
                                        <div>
                                            <figure><img alt="jobhub" src={mediaUrl+"PraImg.jpeg?"+sasToken}/></figure>
                                            <div className="job-info-creator">
                                                <strong>Prasad</strong>
                                                <span>UI/UX Designer</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <figure><img alt="jobhub" src={mediaUrl+"ava_14.png?"+sasToken}/></figure>
                                            <div className="job-info-creator">
                                                <strong>Deepak Moolya</strong>
                                                <span>Software Engineer</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <figure><img alt="jobhub" src={mediaUrl+"ava_15.png?"+sasToken}/></figure>
                                            <div className="job-info-creator">
                                                <strong>Ashwini Bhor</strong>
                                                <span>Photographer</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <figure><img alt="jobhub" src={mediaUrl+"marc4.png?"+sasToken}/></figure>
                                            <div className="job-info-creator">
                                                <strong>Akhilesh Yadav</strong>
                                                <span>Designer</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>



<div className="section-box py-5">
    <div className="container px-4 px-lg-5">
      
        <div className="row justify-content-center mb-4">
            <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
               <img src={mediaUrl+"samsung.svg?"+sasToken} className="img-fluid hover-opacity animate__animated animate__fadeInUp" />

            </div>
            <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                <a href="#"><img src={mediaUrl+"google_002.svg?"+sasToken} alt="Google" className="img-fluid hover-opacity"/></a>
            </div>
            <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                <a href="#"><img src={mediaUrl+"faceboook.svg?"+sasToken} alt="Facebook" className="img-fluid hover-opacity"/></a>
            </div>
            <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                <a href="#"><img src={mediaUrl+"pinterest.svg?"+sasToken} alt="Pinterest" className="img-fluid hover-opacity"/></a>
            </div>
        </div>

       
        <div className="row justify-content-center mb-4">
            <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                <a href="#"><img src={mediaUrl+"avaya.svg?"+sasToken} alt="Avaya" className="img-fluid hover-opacity"/></a>
            </div>
            <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                <a href="#"><img src={mediaUrl+"forbes.svg?"+sasToken} alt="Forbes" className="img-fluid hover-opacity"/></a>
            </div>
            <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                <a href="#"><img src={mediaUrl+"avis.svg?"+sasToken} alt="Avis" className="img-fluid hover-opacity"/></a>
            </div>
            <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                <a href="#"><img src={mediaUrl+"nielsen.svg?"+sasToken} alt="Nielsen" className="img-fluid hover-opacity"/></a>
            </div>
        </div>

        
        <div className="row justify-content-center">
            <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                <a href="#"><img src={mediaUrl+"doordash.svg?"+sasToken} alt="DoorDash" className="img-fluid hover-opacity"/></a>
            </div>
        </div>
    </div>
</div>


<GFooter/>
</div>
    </div>
);
}
export default GJobsIndex;